import LoginForm from "./ResetPasswordForm";

export default LoginForm;
